import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import svgIcon from '@/components/icon/svg'
import preloader from '@/components/preloader'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-5'
    },
    [ h(preloader) ]
  )
}

function renderButton(h, method) {
  const isSelected = this.proxy === method
  let color = Colors.grey
  let mode = buttonModes.flat
  if (isSelected) {
    color = Colors[method]
    mode = buttonModes.filled
  }

  return h(
    button,
    {
      props: {
        label: this.getTranslate(`${Services.payments}.methods.${method}`),
        iconSVG: method,
        color,
        mode,
        disabled: this.isDisabled
      },
      on: {
        click: () => {
          this.proxy = method
        }
      }
    }
  )
}
function renderButtons(h) {
  if (this.loading) {
    return renderPreloader.call(this, h)
  }

  return h(
    'div',
    {
      class: `${Services.payments}-method-buttons`
    },
    [
      this.displayItems.map(item => {
        return renderButton.call(this, h, item.value)
      })
    ]
  )
}

function renderSelectionItem(h, item) {
  let as = 'select'
  if (this.dense) {
    as = 'select-dense'
  }

  return h(
    tag,
    {
      props: {
        label: item.title,
        color: Colors[item.value],
        as
      }
    }
  )
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${Services.payments}-method-item`
    },
    [
      h(
        squircle,
        {
          props: {
            color: item.value,
            tooltip: this.getTranslate(`${Services.payments}.methods.${item.value}`)
          }
        },
        [
          h(
            svgIcon,
            {
              props: {
                value: item.value,
                color: item.value
              }
            }
          )
        ]
      ),
      h(
        textOverflow,
        {
          props: {
            value: item.title
          }
        }
      )
    ]
  )
}
function renderSelect(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${Services.payments}.labels.method`),
        items: this.displayItems,
        labelMode: this.labelMode,
        loading: this.loading,
        disabled: this.isDisabled,
        clearable: this.clearable,
        required: this.required,
        dense: this.dense,
        details: false
      },
      on: {
        input: event => {
          this.proxy = event
        }
      },
      scopedSlots: {
        selection: ({ item }) => {
          return renderSelectionItem.call(this, h, item)
        },
        item: ({ item }) => {
          return renderItem.call(this, h, item)
        }
      }
    }
  )
}

export default function(h) {
  switch (this.as) {
    case 'buttons': return renderButtons.call(this, h)
    case 'select':
    default: return renderSelect.call(this, h)
  }
}
